<template>
  <jc-dialog ref="dialog" :show.sync="show"
             btn-confirm-text='<i class="far fa-trash-alt"></i> Xóa'
             title="Xác nhận xóa"
             type="red"
             @onConfirm="onDelete()"
  >
    <table class="table table-hover">
      <tr>
        <th>#</th>
        <td>{{ model.index }}</td>
      </tr>
      <tr>
        <th>Shop code</th>
        <td>{{ model.shop_code }}</td>
      </tr>
      <tr>
        <th>Tính năng</th>
        <td>{{ model.type }}</td>
      </tr>
    </table>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "Delete",
  mixins: [
    dialogMixins,
  ],
  data() {
    return {
      model: {
        type: null,
        shop_code: null,
      },
      show: false
    }
  },
  methods: {
    open(item) {
      if (item) {
        this.show = true;
        this.model = item;
      } else {
        this.$warning('Chưa chọn bản ghi nào')
      }
    },
    resetForm() {
      this.model = {};
    },
    onDelete() {
      this.$showLoader();
      const vue = this;
      let data = vue.model;
      vue.$http
         .post("/moshop/api/fulfilment/config/shop/close-feature",
             {
               "type" : this.model.type,
               "shop_codes": [this.model.shop_code]
             }
         )
         .then(successRes => {
           this.close();
           this.$success();
           this.$stopLoader();

           this.$emit("success", successRes);
         }, errorRes => {
           this.$stopLoader();
           this.errorNotify(errorRes)
               .then(errorRes => this.$cmsBadRequest(errorRes));
           this.$emit("error", errorRes);
         });
    }
  }
}
</script>

<style scoped>

</style>